import { render, staticRenderFns } from "./askLeave.vue?vue&type=template&id=3dbc14df&"
import script from "./askLeave.vue?vue&type=script&lang=js&"
export * from "./askLeave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports